import BaseDropdownButton, {
  DropdownButtonProps as BaseDropdownButtonProps,
} from 'antd/lib/dropdown/dropdown-button'

export interface DropdownButtonProps extends BaseDropdownButtonProps {}

export const DropdownButton = (props: DropdownButtonProps): JSX.Element => (
  <BaseDropdownButton {...props} />
)
